import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { FileText, Plus, History, ArrowRight, Clock, Share2, MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { UsageCard } from '../components/dashboard/UsageCard';
export function Dashboard() {
  const {
    user
  } = useUser();
  return <div className="container py-4 md:py-8 px-4 md:px-6" data-id="element-1692">
      <div className="mb-6 md:mb-8" data-id="element-1693">
        <h1 className="text-2xl md:text-3xl font-bold" data-id="element-1694">Dashboard</h1>
        <p className="text-muted-foreground mt-2" data-id="element-1695">
          Welcome back{user?.email ? `, ${user.email.split('@')[0]}` : ''}!
          Manage your transcriptions and account.
        </p>
      </div>

      {/* Usage Card with Pricing */}
      <UsageCard data-id="element-1696" />

      {/* Quick Actions */}
      <div className="mb-8" data-id="element-1697">
        <h2 className="text-xl font-semibold mb-4" data-id="element-1698">Quick Actions</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-1699">
          <Link to="/app/transcriptions" data-id="element-1700">
            <Card className="h-full hover:border-primary/50 hover:shadow-sm transition-all" data-id="element-1701">
              <CardContent className="p-6 flex flex-col h-full" data-id="element-1702">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-4" data-id="element-1703">
                  <FileText size={18} className="text-primary" data-id="element-1704" />
                </div>
                <h3 className="font-medium mb-2" data-id="element-1705">View Transcriptions</h3>
                <p className="text-sm text-muted-foreground mb-4 flex-grow" data-id="element-1706">
                  Browse all your saved transcriptions
                </p>
                <Button variant="outline" className="mt-auto w-full justify-between" data-id="element-1707">
                  View All
                  <ArrowRight size={16} data-id="element-1708" />
                </Button>
              </CardContent>
            </Card>
          </Link>
          <Link to="/app/transcriptions" data-id="element-1709">
            <Card className="h-full hover:border-primary/50 hover:shadow-sm transition-all" data-id="element-1710">
              <CardContent className="p-6 flex flex-col h-full" data-id="element-1711">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-4" data-id="element-1712">
                  <Plus size={18} className="text-primary" data-id="element-1713" />
                </div>
                <h3 className="font-medium mb-2" data-id="element-1714">New Transcription</h3>
                <p className="text-sm text-muted-foreground mb-4 flex-grow" data-id="element-1715">
                  Transcribe a new TikTok or YouTube video
                </p>
                <Button className="mt-auto w-full justify-between" data-id="element-1716">
                  Start New
                  <ArrowRight size={16} data-id="element-1717" />
                </Button>
              </CardContent>
            </Card>
          </Link>
          <Link to="/app/history" data-id="element-1718">
            <Card className="h-full hover:border-primary/50 hover:shadow-sm transition-all" data-id="element-1719">
              <CardContent className="p-6 flex flex-col h-full" data-id="element-1720">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-4" data-id="element-1721">
                  <History size={18} className="text-primary" data-id="element-1722" />
                </div>
                <h3 className="font-medium mb-2" data-id="element-1723">Recent Activity</h3>
                <p className="text-sm text-muted-foreground mb-4 flex-grow" data-id="element-1724">
                  View your recent transcription history
                </p>
                <Button variant="outline" className="mt-auto w-full justify-between" data-id="element-1725">
                  View History
                  <ArrowRight size={16} data-id="element-1726" />
                </Button>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>

      {/* SMS Instructions */}
      <div className="mb-8" data-id="element-1727">
        <h2 className="text-xl font-semibold mb-4" data-id="element-1728">Text to Transcribe</h2>
        <Card className="bg-secondary/20" data-id="element-1729">
          <CardContent className="p-6" data-id="element-1730">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6" data-id="element-1731">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-1732">
                <MessageSquare size={20} className="text-primary" data-id="element-1733" />
              </div>
              <div className="flex-grow" data-id="element-1734">
                <h3 className="font-medium mb-1" data-id="element-1735">
                  Text Any TikTok URL to (774) 472-7423
                </h3>
                <p className="text-sm text-muted-foreground" data-id="element-1736">
                  The fastest way to transcribe videos - just text the URL to
                  our number and get an instant transcript.
                </p>
              </div>
              <div className="flex-shrink-0 mt-4 md:mt-0" data-id="element-1737">
                <Button variant="outline" className="flex items-center" data-id="element-1738">
                  <Share2 size={16} className="mr-2" data-id="element-1739" />
                  Share Number
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Recent Transcriptions Teaser */}
      <div data-id="element-1740">
        <div className="flex justify-between items-center mb-4" data-id="element-1741">
          <h2 className="text-xl font-semibold" data-id="element-1742">Recent Transcriptions</h2>
          <Link to="/app/transcriptions" data-id="element-1743">
            <Button variant="ghost" size="sm" className="text-primary" data-id="element-1744">
              View All
              <ArrowRight size={16} className="ml-1" data-id="element-1745" />
            </Button>
          </Link>
        </div>
        <div className="text-center py-8 bg-secondary/20 rounded-lg border border-border/40" data-id="element-1746">
          <Clock size={24} className="mx-auto mb-3 text-muted-foreground" data-id="element-1747" />
          <p className="text-muted-foreground" data-id="element-1748">
            Your recent transcriptions will appear here
          </p>
          <Link to="/app/transcriptions" data-id="element-1749">
            <Button className="mt-4" data-id="element-1750">Start Transcribing</Button>
          </Link>
        </div>
      </div>
    </div>;
}